export default __webpack_public_path__ + "images/joining-forces.svg";